import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { catchError, map } from 'rxjs/operators';
import { Merchant } from '../models/merchant';
import { MappingTable } from '../models/mappingTable';

@Injectable({ providedIn: 'root' })
export class MappingTableService {

    isSaveNeeded: boolean = false;

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService
    ) { }

    mappingTableSaveNeededSubject = new Subject<any[]>();
    mappingTableSubject = new Subject<Array<MappingTable>>();

    getMappingTableByMerchantId(merchantId): Observable<Array<MappingTable>> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlMappingTable}/merchant/${merchantId}`).pipe(catchError(err => {
            if (err.status == "404") {
                console.log("error", err);
            } else {
                this.notifService.notifyErrorWithDetailFromApi('ERROR_MAPPING_TABLE_API', err);
            }
            let emptyItem = new Array<MappingTable>();
            return of(emptyItem);
        }));
    }

    deleteMappingTable(id): Observable<MappingTable> {
        return this.http.delete<Merchant>(`${this.configService.config.urlAPI.urlMappingTable}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MAPPING_TABLE_API', err);
            return of(null);
        }));
    }

    updateMappingTable(mappingTable: MappingTable): Observable<MappingTable> {
        return this.http.put<MappingTable>(this.configService.config.urlAPI.urlMappingTable, mappingTable).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MAPPING_TABLE_API', err);
            return of(null);
        }));
    }

    createMappingTable(mappingTable: MappingTable): Observable<MappingTable> {
        return this.http.post<MappingTable>(this.configService.config.urlAPI.urlMappingTable, mappingTable).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MAPPING_TABLE_API', err);
            return of(null);
        }));
    }

}
